<template>
  <!-- 提币外层宽度 w100% -->
  <!-- <div class="comp-container"> -->
  <div class="mention-money">
    <PageHeader url="/myassets" :title="$t('提币')"></PageHeader>

    <section class="content_auto">
      <!-- 币种 - 开始 -->
      <h2 class="mention-money-second-title">{{ $t('币种') }}</h2>
      <Select
        v-model="coinId"
        class="money-type-select"
        :placeholder="$t('请选择币种')"
        size="large"
      >
        <Option v-for="item in coinList" :value="item.id" :key="item.name">
          {{ item.name.toUpperCase() }}
        </Option>
      </Select>
      <!-- 币种 - 结束 -->

      <!-- 链 - 开始 -->
      <template v-if="chainList.length">
        <h2 class="mention-money-second-title">
          {{ $t('链名称') }}
        </h2>
        <div class="chain-name-list">
          <span
            v-for="chain in chainList"
            :key="chain.id"
            :class="{
              'chain-name-item': true,
              'chain-name-item-active': currentChain == chain,
            }"
            @click="switchChain(chain)"
          >
            {{ chain.name.toUpperCase() }}
          </span>
        </div>
      </template>
      <!-- 链 - 结束 -->

      <!-- 提币账户信息 - 开始 -->
      <div class="account-info" v-if="coinId">
        <h1 class="mention-money-second-title">{{ $t('提币地址') }}</h1>
        <div class="account-box">
          <el-input v-model="account" class="account-input" size="large" />
        </div>
        <div class="transfer-box">
          <h1 class="mention-money-second-title">{{ $t('提币数量') }}</h1>
          <el-input
            :value="transferNum"
            class="transfer-input"
            size="large"
            @input="handleInput"
          >
            <template #suffix>
              <div class="transfer-type">
                <span class="transfer-money-type">
                  {{ coinName }}
                </span>
                <span
                  class="transfer-money-all"
                  @click="transferNum = amountUsable"
                >
                  {{ $t('全部提币') }}
                </span>
              </div>
            </template>
          </el-input>
          <!--  余额  -->
          <div class="balance-box">
            {{ $t('可用') }}
            <span class="balance-num">
              {{ amountUsable }}
            </span>
            {{ coinName }}
          </div>
        </div>
        <div class="code-wrapper">
          <h1 class="mention-money-second-title">
            {{ codeText }}
            <i
              v-if="userInfo.email && userInfo.phone"
              class="el-icon-sort"
              @click="trigger = !trigger"
            ></i>
          </h1>
          <div class="code-box">
            <el-input
              v-model.trim="code"
              size="large"
              :placeholder="codePlaceholder"
            />
            <verify-code @click="getCode"></verify-code>
          </div>
        </div>

        <div v-if="currentCoin" class="recharge-tip-wrapper">
          <div class="recharge-tip-title">
            {{ $t('温馨提示') }}
          </div>
          <div v-if="+currentCoin.withdrawMin" class="recharge-tip-box">
            <div class="recharge-tip-icon"></div>
            <div class="recharge-tip-content">
              {{ $t('最小提币数量为') }}：
              <span>{{ currentCoin.withdrawMin }}</span>
              {{ coinName }}
            </div>
          </div>
          <div v-if="+currentCoin.withdrawMax" class="recharge-tip-box">
            <div class="recharge-tip-icon"></div>
            <div class="recharge-tip-content">
              {{ $t('最大提币数量为') }}：
              <span> {{ currentCoin.withdrawMax }}</span>
              {{ coinName }}
            </div>
          </div>
        </div>

        <div class="handling-fee">
          {{ $t('手续费') }} <span>{{ withdrawFee }}</span>
        </div>

        <div class="arrive">
          {{ $t('预期到账') }}<span>{{ realToAccount }} {{ coinName }}</span>
        </div>

        <el-button
          class="submit-btn"
          type="primary"
          :class="{ 'disabled-submit': !canSubmit }"
          :disabled="!canSubmit"
          :loading="btnLoading.submit"
          @click="mentionMoneyHandle"
        >
          {{ $t('提交') }}
        </el-button>
      </div>
      <!-- 提币账户信息 - 结束 -->

      <h2 class="mention-money-log-title">
        <span>{{ $t('提币记录') }}</span>
      </h2>

      <table class="mention-money-log-table">
        <tr>
          <th>{{ $t('时间') }}</th>
          <th>{{ $t('流水号') }}</th>
          <th class="address">{{ $t('提币地址') }}</th>
          <th>{{ $t('币种') }}</th>
          <th>{{ $t('提币数量') }}</th>
          <th>{{ $t('手续费') }}</th>
          <th>{{ $t('状态') }}</th>
        </tr>
      </table>

      <table class="mention-money-log-table content-table">
        <tr v-for="item in withdrawalRecordList" :key="item.id">
          <td>{{ item.time }}</td>
          <td>{{ item.id }}</td>
          <td class="address">{{ item.toAddress }}</td>
          <td>{{ item.coinName }}</td>
          <td>{{ item.num }}</td>
          <td>{{ item.feeNum }}</td>
          <td>{{ item.statesKey | filterStates($t) }}</td>
        </tr>
      </table>

      <Page
        v-if="withdrawalRecordList.length"
        size="small"
        class-name="page-con"
        :current.sync="page.current"
        :total="page.total"
        :page-size="7"
        @on-change="changePage"
      />
      <NoData v-else height="200px" sceneType="day"></NoData>
    </section>

    <TradingPassDialog
      v-model="showTradingPassDialog"
      @trading="handleTrading"
    />
  </div>
  <!-- </div> -->
</template>

<script>
import {
  ajax_getAuthorizationStatus,
  fetchAllCoins,
  ajaxPost_MentionMoney,
  // ajaxGet_cancelMentionMoney,
  getWithdrawRecordAPI,
  fetchAmountUsableyCoinId,
} from '@/api/assets'
import { Big } from 'big.js'
import { ajaxSmsHandle } from '@/utils'
import { vm } from '@/main'
import { mapState } from 'vuex'
import { ajax_sendSms } from '@/api/personal'
import TradingPassDialog from '@/views/transaction/components/TradingPassDialog'
export default {
  name: 'MentionMoney',
  components: {
    TradingPassDialog,
  },
  filters: {
    filterStates(states) {
      return {
        SHZ: vm.$t('审核中'),
        ZBZ: vm.$t('转币中'),
        CLZ: vm.$t('处理中'),
        DQR: vm.$t('待确认'),
        YWC: vm.$t('已完成'),
        YQX: vm.$t('已取消'),
        SHSB: vm.$t('审核失败'),
      }[states]
    },
  },
  data() {
    return {
      showTradingPassDialog: false, //
      trigger: false, // 手机、邮箱验证码切换flag
      code: '', // 验证码
      btnLoading: {
        submit: false,
      },
      account: '', // 转账地址
      transferNum: '', // 转账数量
      coinId: +this.$route.query.coinId || '', // 币种ID
      coinList: [], // 用于币种选择框的 列表数据
      currentChain: null, // 当前链
      withdrawalRecordList: [], // 提币记录
      page: {
        current: 1,
        total: 0,
      },
      amountUsable: '0', // 币种可用数量
    }
  },
  watch: {
    /** 选中币种时，获取币种可用数量，同时切换当前链为当前币种支持的链中的第一条链 */
    coinId: {
      async handler(newV) {
        this.currentChain = this.currentCoin.chains[0]
        await this.getAmountUsableByCoinId(newV)
        this.resetData()
        this.getMentionMoneyRecord(0)
      },
    },
  },
  computed: {
    ...mapState(['userInfo']),
    // 验证码类型 1 手机 2 邮箱
    nick() {
      if (this.userInfo.isPhone) {
        return this.trigger ? 2 : 1
      } else {
        return this.trigger ? 1 : 2
      }
    },
    // 验证码文案
    codeText() {
      return { 1: this.$t('短信验证码'), 2: this.$t('邮箱验证码') }[this.nick]
    },
    // 验证码placeholde
    codePlaceholder() {
      return { 1: this.$t('请输入短信验证码'), 2: this.$t('请输入邮箱验证码') }[
        this.nick
      ]
    },
    canSubmit() {
      return this.account && this.transferNum && this.code
    },
    // 当前币种
    currentCoin() {
      return this.coinList.find((coin) => coin.id === this.coinId)
    },
    // 当前币种名称
    coinName() {
      if (this.currentCoin) {
        return this.currentCoin.name.toUpperCase()
      }
      return ''
    },
    // 当前币种支持的链
    chainList() {
      if (this.currentCoin) {
        return this.currentCoin.chains
      }
      return []
    },
    // 手续费
    withdrawFee() {
      if (this.currentChain) {
        const idx = this.chainList.findIndex(
          (item) => item.id === this.currentChain.id
        )
        return this.currentCoin.chainPoundage[idx]
      }
      return 0
    },
    // 预期到账
    realToAccount() {
      if (!+this.transferNum || !this.currentCoin) {
        return 0
      }
      const transferNum = Big(this.transferNum)

      /*  eslint-disable */
      return transferNum.gt(this.withdrawFee)
        ? transferNum
            .minus(this.withdrawFee)
            .toFixed(this.currentCoin.digitsAmount)
        : 0
      /*  eslint-enable */
    },
  },
  // 校验是否进行了必要的身份认证
  async beforeRouteEnter(to, from, next) {
    try {
      const { c2Status } = await ajax_getAuthorizationStatus()

      if (c2Status === 'Yes') {
        next()
      } else {
        next(false)
        vm.$Modal.confirm({
          title: vm.$t('未完成必要的认证'),
          okText: vm.$t('认证'),
          cancelText: vm.$t('取消'),
          onOk: () => {
            next({ path: '/identity' })
          },
        })
      }
    } catch {
      next(false)
    }
  },
  async mounted() {
    await this.getWithdrawableCoinList()

    if (this.coinId) await this.getAmountUsableByCoinId(this.coinId)

    this.getMentionMoneyRecord(0)
  },
  methods: {
    resetData() {
      this.account = ''
      this.transferNum = ''
      this.page = {
        current: 1,
        total: 0,
      }
    },
    async handleTrading(password) {
      this.showTradingPassDialog = false
      this.btnLoading.submit = true
      try {
        await ajaxPost_MentionMoney({
          password,
          nick: this.nick,
          code: this.code,
          chain: this.currentChain.name,
          num: this.transferNum,
          address: this.account,
          coinId: this.coinId,
        })
        this.$Message.success(this.$t('操作成功'))
        this.resetData()
        this.getMentionMoneyRecord(0)
        this.getAmountUsableByCoinId(this.coinId)
      } finally {
        this.btnLoading.submit = false
      }
    },
    getCode(e) {
      ajaxSmsHandle(
        ajax_sendSms({
          type: 'transferOut',
          nick: this.nick,
          coinCode: this.currentCoin.name,
        }),
        e
      )
    },
    async getAmountUsableByCoinId(coinId) {
      const { amountUsable } = await fetchAmountUsableyCoinId({
        coinId,
      })
      this.amountUsable = amountUsable
    },
    switchChain(chain) {
      if (this.currentChain === chain) {
        return
      }
      this.currentChain = chain
      this.account = ''
    },
    changePage(currentPage) {
      this.getMentionMoneyRecord(currentPage - 1)
    },
    validate() {
      const { withdrawMax, withdrawMin } = this.currentCoin
      if (Big(this.transferNum).gt(this.amountUsable)) {
        this.$Message.error(this.$t('可用不足', { token: this.coinName }))
        return false
      }
      if (Big(this.transferNum).lt(withdrawMin)) {
        this.$Message.error(this.$t('最小提币數量为') + withdrawMin)
        return false
      }
      if (Big(this.transferNum).gt(withdrawMax)) {
        this.$Message.error(this.$t('最大提币數量为') + withdrawMax)
        return false
      }
      return true
    },
    mentionMoneyHandle() {
      if (!this.canSubmit) {
        return
      }
      if (!this.userInfo.isTrade) {
        this.$Modal.confirm({
          title: '您还未设置资金密码，是否现在设置？',
          onOk: () => {
            this.$router.push('/personal')
          },
        })
        return
      }
      if (!this.validate()) {
        return
      }

      this.showTradingPassDialog = true
    },
    // 获取可以提币的代币列表
    async getWithdrawableCoinList() {
      this.coinList = (await fetchAllCoins()).filter(
        (item) => item.isWithdraw === 'S'
      )
      if (this.coinId) {
        const currentCoin = this.coinList.find(
          (coin) => coin.id === this.coinId
        )
        this.currentChain = currentCoin.chains[0]
      }
    },
    async getMentionMoneyRecord(start) {
      const loadingInstance = this.$loading({
        duration: 0,
        target: '.content-table',
      })
      const params = {
        start,
        offset: 7,
      }
      if (this.coinId) {
        params.coinID = this.coinId
      }
      try {
        const { count, item } = await getWithdrawRecordAPI(params)
        this.withdrawalRecordList = item
        this.page.total = count
      } catch {
        this.withdrawalRecordList = []
        this.page.total = 0
      } finally {
        loadingInstance.close()
      }
    },
    handleInput(val) {
      val = val.replace(
        new RegExp(
          `^\\D*(\\d*(?:\\.\\d{0,${this.currentCoin.digitsAmount}})?).*$`,
          'g'
        ),
        '$1'
      )

      if (val === '') {
        this.transferNum = val
        return
      }
      if (val.includes('.')) {
        const [_int, _digit] = val.split('.')
        val = `${Big(_int).toFixed()}.${_digit || ''}`
      } else {
        val = Big(val).toFixed()
      }

      this.transferNum = val
    },
  },
}
</script>
<style scoped lang="less">
.mention-money-second-title {
  font-size: 14px;
  color: #333;
  margin-bottom: 12px;
  margin-top: 20px;
}

.money-type-select {
  width: 480px;
  margin-bottom: 15px;
}

.money-type-recommend {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.money-type-recommend a {
  width: 60px;
  height: 30px;
  background: #f5f6fa;
  margin-right: 10px;
  color: #333333;
  font-size: 16px;
  text-align: center;
  line-height: 30px;
}

.mention-money-log-title {
  font-size: 16px;
  color: #333;
  margin: 50px 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mention-money-alllog-btn {
  color: #42b3fa;
}

.mention-money-log-table {
  .table-base(@w:100%);
  // margin-bottom: 80px;

  & tr td:last-child {
    color: #42b3fa;
  }
  th,
  td {
    width: 14.28%;
    &.address {
      width: 400px !important;
      min-width: 400px;
    }
  }
}

.account-box {
  display: flex;
  align-items: center;
}

.account-input {
  width: 480px;
  margin-right: 10px;
}

.account-box-keycode {
  width: 480px;
  background: #f8fdff;
  border-radius: 4px;
  padding: 15px;
  margin-right: 10px;
  border: 1px solid #dcdee2;

  p {
    color: #333333;
  }

  span {
    color: #999999;
    font-size: 14px;
  }
}

.address-btn {
  color: #42b3fa;
}

.disabled-status {
  // 未选择地址时候的颜色值
  color: #999;
}

/deep/ .transfer-input {
  width: 480px;

  input {
    padding-right: 178px;
  }
}

/deep/ .ivu-input-suffix {
  // 更改input框内部后置内容宽度
  width: auto;
}

.transfer-type {
  display: flex;
  justify-content: flex-end;
  height: 100%;
  align-items: center;
}

.transfer-money-type {
  color: #333333;
}

.transfer-money-all {
  width: 92px;
  color: #42b3fa;
  cursor: pointer;
}

.balance-box {
  color: #999999;
  margin-top: 10px;
}

.balance-num {
  color: #333333;
}

.handling-fee {
  margin-top: 50px;
  color: #999999;
  margin-bottom: 10px;

  span {
    font-size: 18px;
    margin-left: 10px;
    color: #333333;
  }
}

.arrive {
  color: #999999;

  span {
    color: #333;
    margin-left: 10px;
  }
}

.submit-btn {
  width: 120px;
  height: 50px;
  border-radius: 4px;
  margin-top: 20px;
  font-size: 18px;
  &.disabled-submit {
    border: 1px solid #979797;
    background: #e8e8e8;
    color: #999;
    cursor: not-allowed;
  }
}

/deep/ .page-con {
  .page-base();
  margin: 50px auto 200px;
}

.chain-name-item {
  padding: 7px 15px;
  background: #f8f8f8;
  color: #333;
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
  border: 1px solid transparent;
}

.chain-name-item-active {
  border-color: #42b3fa;
  color: #42b3fa;
  background: #fff;
}

.recharge-tip-wrapper {
  margin-top: 20px;
  .recharge-tip-title {
    color: red;
    margin-bottom: 8px;
  }
  .recharge-tip-box {
    margin-bottom: 5px;
    display: flex;
    .recharge-tip-icon {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #42b3fa;
      align-self: center;
      margin-right: 4px;
    }
    .recharge-tip-content {
      font-size: 12px;
      span {
        color: red;
      }
    }
  }
}
.code-box {
  display: flex;
  width: 480px;
  .el-input {
    margin-right: 10px;
  }
}
</style>
